/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LanguageLevel = {
    Basic: 'BASIC',
    Conversational: 'CONVERSATIONAL',
    Fluent: 'FLUENT',
    Native: 'NATIVE'
} as const;
export type LanguageLevel = typeof LanguageLevel[keyof typeof LanguageLevel];


export function instanceOfLanguageLevel(value: any): boolean {
    for (const key in LanguageLevel) {
        if (Object.prototype.hasOwnProperty.call(LanguageLevel, key)) {
            // @ts-ignore
            if (LanguageLevel[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LanguageLevelFromJSON(json: any): LanguageLevel {
    return LanguageLevelFromJSONTyped(json, false);
}

export function LanguageLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageLevel {
    return json as LanguageLevel;
}

export function LanguageLevelToJSON(value?: LanguageLevel | null): any {
    return value as any;
}

